import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AppPermissions } from 'src/app/shared/app.permissions';

@Component({
  selector: 'ness-crime-gun-firearm-detail',
  templateUrl: './crime-gun-firearm-detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    '@media (min-width >= 768px) { .col-sm-3, .col-md-4 { text-align: right; } }',
    '.col-sm-3, .col-md-4 { margin-bottom: 0.4375rem; margin-top: 0.4375rem; }',
    '.col-sm-9, .col-md-8 { font-weight: 700; margin-bottom: 0.4375rem; margin-top: 0.4375rem; }'
  ]
})
export class CrimeGunFirearmDetailComponent {
  @Output() closeFirearmView = new EventEmitter();

  readonly canViewFTS = AppPermissions.canViewTraceData;

  private _gunDetailCustomFields: ServerModels.GunDetailCustomFields;
  get gunDetailCustomFields(): ServerModels.GunDetailCustomFields {
    return this._gunDetailCustomFields;
  }
  @Input() set gunDetailCustomFields(customFields: ServerModels.GunDetailCustomFields) {
    this._gunDetailCustomFields = customFields;
  }

}
